import { usePermissions } from "components/context/permissionsContext";

export const useWorkOrderPermission = () => {
  const { userPermissions } = usePermissions();

  const hasWorkOrderGetPermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "WorkOrder" &&
      item.identifier === "workorder-get" &&
      item.hasPermission
  );
  const hasWorkOrderSavePermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "WorkOrder" &&
      item.identifier === "workorder-save" &&
      item.hasPermission
  );
  const hasWorkOrderDeletePermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "WorkOrder" &&
      item.identifier === "workorder-delete" &&
      item.hasPermission
  );

  const WorkOrderPermissionProps = {
    hasWorkOrderGetPermission,
    hasWorkOrderSavePermission,
    hasWorkOrderDeletePermission,
  };

  return {
    WorkOrderPermissionProps,
  };
};
